import { trackError } from 'services/analytics'
import { NextPageContext } from 'next'

export function getAuthCookie(req: NextPageContext['req']): string | null {
  try {
    return req?.headers?.cookie || null
  } catch (error) {
    trackError(error)
    return null
  }
}
